<template lang="pug">
.channel-categories.inset
  .left-side.p-5.inset(ref="wrapper", :class="{'visible': activeSection!=='list', 'surface-bg-darker-90':transparent, 'surface-bg-darker':!transparent  }")
    .search.mb-3(
      v-nv:scope="'channel-categories-search'",
      @nv-noway-right="section('list')",
      @nv-back="section('search')",
      @nv-scope-blur="blurred",
      data-down="channel-categories"
    )
      pr-subtitle.side-title.text-muted {{ $t("Search") }}
      pr-input.background(:label="$t('Channel Search')", :value.sync="search", text, icon="search", floated, fluid, small)

    .categories.overflow-hidden
      pr-subtitle.side-title.text-muted {{ $t("Categories") }}
      .categories-wrapper.overflow-hidden(
        v-nv:scope="'channel-categories'",
        data-scroll="center",
        data-up="channel-categories-search",
        @nv-noway-right="section('list')",
        @nv-scope-focus="focused",
        @nv-scope-blur="blurred",
        @nv-back="section()"
      )
        .scroll-container
          .category.side-item(v-nv, @nv-enter="choose('favorites')", :id="'favorites'", v-show="favoritesChannels.length")
            .background.border(:class="{ 'inactive-element': category === 'favorites' }")
              i.fal.fa-heart.mr-2
              | {{ $t("My Favorites") }}
          .category.side-item(v-nv, @nv-enter="choose('records')", :id="'records'", v-show="completedRecords.length")
            .background.border(:class="{ 'inactive-element': category === 'records' }")
              i.fal.fa-save.mr-2
              | {{ $t("My Records") }}

          .category.side-item(v-for="item in categories_", v-nv, @nv-enter="choose(item.key)", :id="(item.key || 'all-channels') | slugify")
            .background.border(:class="{ 'inactive-element': category === item.key }") {{ item.value }}
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "channel-categories",
  props: ["activeSection"],
  data() {
    return {
      refreshScope: false
    }
  },
  computed: {
    transparent() {
      return __.device.config("tv_list_behaviour.tv_list_behaviour") === "transparent"
    },
    categories_() {
      let res = this.$store.getters["live/categories"]
        .filter(item => !this.privateCategories.includes(item))
        .slice()
        .map(item => {
          return { key: item, value: item }
        })

      res.unshift({ key: null, value: "All Channels" })

      return res
    },
    search: {
      get: () => this_.$store.state.live.search,
      set: value => this_.$store.commit("live/search", value)
    },
    category: {
      get: () => this_.$store.state.live.category,
      set: value => this_.$store.commit("live/category", value)
    },
    ...mapGetters("live", ["favoritesChannels", "channels", "categories", "channel", "completedRecords", "privateCategories"])
  },
  watch: {
    favoritesChannels(nval, oval) {
      if (!nval.length && oval.length && this.category === "favorites") this.category = null
    },
    search(nval, oval) {
      if (!oval && nval) this.category = null
    },
    category(nval) {
      if (nval) this.search = null
    },
    async categories_() {
      if (this._inactive) {
        this.refreshScope = true
        return
      }
      await this.$nextTick()
      this.syncCategoriesNavigation()
    }
  },
  deactivated() {
    this.search = null
  },
  activated() {
    if (this.refreshScope) this.syncCategoriesNavigation()
  },
  mounted() {
    _$.nav.sync("channel-categories")
    _$.nav.sync("channel-categories-search")
  },
  methods: {
    blurred() {
      if (!this.channels.find(item => item === this.channel)) this.$store.commit("live/channel", this.channels[0])
    },
    async focused() {
      this.$store.state.live.sidebar = "categories"
      if (this.search && _$.nav._prevScope.name === "channel-list") _$.nav.sync("channel-categories-search", true)
      else _$.nav.move(document.getElementById(this.category?.slugify() || "all-channels"))
    },
    choose(category_) {
      if (category_ === "records") return this.showRecords()
      if (this.search) this.search = null
      if (this.category === category_) return this.section("list")
      this.category = category_
    },
    section(to = null) {
      if (to === "search" && this.search) return
      else if (to === "search" && !this.search) to = "osd"
      this.$emit("section", to)
    },
    async showRecords() {
      if (!this.completedRecords.length) return
      let options = []

      this.completedRecords.forEach(record => {
        const image = this.$store.state.live.channels[record.id]?.logo,
          date = this.$moment(record.start * 1000).format("ddd, MMM Do"),
          duration = this.$moment.duration(record.duration * 1000).humanize()

        const subvalue = `${date} - ${duration}`
        options.push({ key: record.proc_id, value: record.title, image: image, subvalue: subvalue, type: "image" })
      })
      __.platform.fullscreen(true)
      let result = await _$.vue.$sidepane(_$.vue.$t("My Records"), _$.vue.$t("Select a record you want to play"), options)
      result = this.completedRecords.find(record => record.proc_id == result)
      __.platform.fullscreen(false)
      if (!result) return false

      const channel = this.$store.state.live.channels[result.id]
      if (!channel) return false
      if (channel.pin) {
        const res = await __.media.pinCodeMiddleware(channel)
        if (!res) return false
      }

      const record_uri = `${result.resource_mp4 || result.source}`.host(`/media/records/videos/${result.pms_id || "General"}/`)

      if (__.media.isActive()) await __.media.stop()

      await this.$popup.videoWithPlayerControl(record_uri, false)
      if (this.channel) __.media.play(this.channel.channel_uri, true, this.channel)
    },
    syncCategoriesNavigation() {
      _$.nav.sync("channel-categories")
      if (_$.nav.currentScopeName("channel-categories")) _$.nav.move(document.getElementById(this.category?.slugify() || "all-channels"))
      this.refreshScope = false
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-categories {
  display: flex;
  left: 60px;

  .left-side {
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    visibility: hidden;

    &.visible {
      visibility: visible !important;
    }

    .side-title {
      margin: 0 0 0.5em 0;
    }
    .side-item {
      margin-bottom: 5px;

      &:last-child {
        margin-bottom: 0 !important;
      }

      div {
        width: 100%;
        text-align: left;
        padding: 0.5em 0.75em;
        height: 45px;
        display: flex;
        align-items: center;
      }
    }
  }

  .categories {
    display: flex;
    flex-direction: column;

    .scroll-container {
      position: relative;
      display: inline-block;
      width: 100%;
    }
  }
}
</style>
